import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Button from '@zenbusiness/zui/Button';

import { CHECKOUT } from '#client/pages/Checkout/constants';

function ContinueButton({ children, type, ...delegated }) {
  return (
    <Button
      clickstreamProps={{
        elementName: 'checkout_card_continue',
        elementValue: CHECKOUT.STEP.BUSINESS
      }}
      color="primary"
      data-testid={`checkout-card-continue-${CHECKOUT.STEP.BUSINESS}`}
      fullWidth
      type={type}
      variant="contained"
      {...delegated}
    >
      {type === 'submit' ? (
        <FormattedMessage id="shopping.page.checkout.saveAndContinue" />
      ) : (
        <FormattedMessage id="shopping.page.checkout.continue" />
      )}
    </Button>
  );
}

ContinueButton.propTypes = {
  type: PropTypes.string
};

export default ContinueButton;
